import { ActionBar, ButtonVariant } from '@dreryk/react-components';

import { translationKeys } from '../../translations';
import { GroupSessionsCreateModalOpener } from '../../create/GroupSessionsCreateModal.opener';

export const GroupsSessionsCreateAction = (): JSX.Element => {
   return (
      <GroupSessionsCreateModalOpener>
         {({ openModal }) => (
            <ActionBar.PrimaryButton
               testId={'groupSessionsCreate'}
               label={translationKeys.createTherapeuticGroup}
               variant={ButtonVariant.PRIMARY}
               onClick={openModal}
            />
         )}
      </GroupSessionsCreateModalOpener>
   );
};
